import { render, staticRenderFns } from "./OtolierMock.vue?vue&type=template&id=3c5dee3a&scoped=true&"
import script from "./OtolierMock.vue?vue&type=script&lang=js&"
export * from "./OtolierMock.vue?vue&type=script&lang=js&"
import style0 from "./OtolierMock.vue?vue&type=style&index=0&id=3c5dee3a&scoped=true&lang=css&"
import style1 from "./OtolierMock.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dee3a",
  null
  
)

export default component.exports